import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "chat-dialog__logo" }
const _hoisted_2 = {
  key: 0,
  class: "chat-dialog__logo-img",
  alt: "Avatar"
}
const _hoisted_3 = { class: "chat-dialog__body" }
const _hoisted_4 = { class: "chat-dialog__body-header" }
const _hoisted_5 = { class: "chat-dialog__body-header-title" }
const _hoisted_6 = { class: "chat-dialog__body-header-datetime" }
const _hoisted_7 = { class: "chat-dialog__body-header-datetime-text" }
const _hoisted_8 = {
  key: 0,
  class: "chat-dialog__body-message-logo",
  alt: "Avatar"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 1,
  class: "chat-dialog__body-message-unreaded-count"
}

import { computed, ref } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import DialogDeleteConfirm from "@/components/main/chat-panel/dropdowns/DialogDeleteConfirm.vue";
import moment from "moment/moment";
import { Dialog } from "@/store/chats";
import { formatJoinedUsersMessage, highlightSearchText } from "@/utils/textHelpers";

type ChatDialogProps = {
	dialog: Dialog,
	fromSearch?: string
}

const DRAG_THRESHOLD = 4

export default /*@__PURE__*/_defineComponent({
  __name: 'ChatDialog',
  props: {
    dialog: {},
    fromSearch: {}
  },
  emits: ["on-delete", "on-open"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $deleteDialog = ref<typeof AppResizableDropdown | null>(null)
const $root = ref<HTMLElement | null>(null)

const dialogMoment = moment(props.dialog.MessageDate);
const dialogDate = dialogMoment.format("DD.MM.YYYY");
const dialogTime = dialogMoment.format("HH:mm");

const messagePreview = computed(() => {
	const message = formatJoinedUsersMessage(props.dialog.Message ?? '');

	if (props.fromSearch) {
		return highlightSearchText(props.fromSearch, message);
	}

	// у обычных многострочных сообщений в превью показываем только первую строку
	return message.split('\n')[0];
});

// порог в пикселях, ниже которого движение мыши считается кликом, а не протяжкой
const mouseDownPosition = ref<{ x: number, y: number } | null>(null)
const onMouseDown = (event: MouseEvent) => {
	mouseDownPosition.value = { x: event.clientX, y: event.clientY }
}

// текст выделен именно в этом диалоге (после протяжки или двойного клика по слову)
const hasSelectionInside = () => {
	const selection = window.getSelection()

	if (!selection || selection.isCollapsed || !selection.toString().trim()) {
		return false
	}

	return !!selection.anchorNode && !!$root.value?.contains(selection.anchorNode)
}

const onDeleteDialog = () => emit("on-delete", props.dialog.Id);
const onOpen = (event: MouseEvent) => {
	if ((event?.target as HTMLElement)?.closest('.link-message')) {
		return
	}

	const startPosition = mouseDownPosition.value
	mouseDownPosition.value = null

	const isDrag = !!startPosition && (
		Math.abs(event.clientX - startPosition.x) > DRAG_THRESHOLD
		|| Math.abs(event.clientY - startPosition.y) > DRAG_THRESHOLD
	)

	if (isDrag || hasSelectionInside()) {
		return
	}

	emit("on-open", props.dialog)
};

return (_ctx: any,_cache: any) => {
  const _directive_img_fade = _resolveDirective("img-fade")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$root",
    ref: $root,
    class: "chat-dialog",
    onMousedown: onMouseDown,
    onClick: onOpen
  }, [
    _createElementVNode("div", _hoisted_1, [
      (props.dialog.PhotoLink)
        ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_2, null, 512)), [
            [_directive_img_fade, props.dialog.PhotoLink]
          ])
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({
					'chat-dialog__logo-text': true,
					'chat-dialog__logo-text--personal': props.dialog.IsPersonal
				})
          }, _toDisplayString(props.dialog.PhotoLiter), 3))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(props.dialog.Name), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_unref(dialogDate)), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(dialogTime)), 1)
          ]),
          _createVNode(AppResizableDropdown, {
            ref_key: "$deleteDialog",
            ref: $deleteDialog,
            name: "$deleteDialog",
            position: "left",
            "max-width": 235,
            "centered-on-mobile": "",
            "close-by-click-outside": ""
          }, {
            activator: _withCtx(() => [
              _createVNode(AppTooltip, {
                class: "chat-dialog__body-header-tooltip",
                text: _ctx.$t('remove'),
                position: "right"
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "chat-dialog__body-header-btn",
                    name: "close-bold",
                    size: "12px",
                    color: "#D2D2D2",
                    "hover-color": "#BA4C4C",
                    cursor: "pointer"
                  })
                ]),
                _: 1
              }, 8, ["text"])
            ]),
            default: _withCtx(() => [
              _createVNode(DialogDeleteConfirm, {
                type: props.dialog.IsPersonal ? 'chat' : 'group',
                name: props.dialog.Name,
                onConfirm: onDeleteDialog,
                onCancel: _cache[0] || (_cache[0] = ($event: any) => ($deleteDialog.value.close()))
              }, null, 8, ["type", "name"])
            ]),
            _: 1
          }, 512)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({
				'chat-dialog__body-message': true,
				'chat-dialog__body-message--unreaded': props.dialog.Unreaded && !props.dialog.UnreadCount,
			})
      }, [
        (props.dialog.ShowSmallPhoto)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (props.dialog.SmallPhotoLink)
                ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_8, null, 512)), [
                    [_directive_img_fade, props.dialog.SmallPhotoLink]
                  ])
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass({
							'chat-dialog__body-message-text-logo': true,
							'chat-dialog__body-message-text-logo--personal': props.dialog.IsPersonal
						})
                  }, _toDisplayString(props.dialog.SmallPhotoLiter), 3))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "chat-dialog__body-message-text",
          innerHTML: messagePreview.value
        }, null, 8, _hoisted_9),
        (props.dialog.UnreadCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(props.dialog.UnreadCount), 1))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 544))
}
}

})